import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

interface CreateNoteCategoriesInput {
  name: string;
  iaActive: boolean;
}
export async function createNoteCategory(input: CreateNoteCategoriesInput) {
  let data;
  data = await axios({
    url: API_URL,
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      query: `
        mutation createNoteCategory(
          $input: CreateNoteCategoriesInput!
        ) {
          createNoteCategory(
            createNoteCategoryInput: $input
          )
        }
      `,
      variables: {
        input,
      },
    },
  }).catch((e: any) => (data = e.response));
  return data;
}

export async function getNoteCategories() {
    const data = await axios({
      url: API_URL,
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        query: `
              query {
                getNoteCategoriesList {
                  id
                  name
                  isActive
                }
              }
              `,
        variables: {},
      },
    });
    return data?.data?.data?.getNoteCategoriesList;
  }
export async function getNoteCategoriesList(where: {} = {}) {
  const data = await axios({
    url: API_URL,
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      query: `
                query getNoteCategories($where:NoteCategoriesResolver_GetNoteCategories_FilterInputType
                  ) {
                    getNoteCategories (where:$where) {
                      data {
                            id
                            name
                            isActive
                            createdAt
                            }
                            totalPages
                            total
                            perPage
                            page
                     }
                  }
                `,
      variables: {where},
    },
  });
  return data?.data?.data?.getNoteCategories;
}

export async function updateNoteCategory(input: CreateNoteCategoriesInput, id: string) {
  let data;
  data = await axios({
    url: API_URL,
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      query: `
        mutation updateNoteCategory (
          $id: String!
          $input: CreateNoteCategoriesInput!
        ) {
          updateNoteCategory(
            id: $id
            createNoteCategoryInput: $input
          )
        }
      `,
      variables: {
        id,
        input,
      },
    },
  }).catch((e: any) => (data = e.response));
  return data;
}


export async function updateNoteCategoriesStatus(id: string, isActive: boolean) {
  let data;
  data = await axios({
    url: API_URL,
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      query: `
       mutation ($id: String!, $isActive: Boolean! ) {
        updateNoteCategoriesStatus(
          updateNoteCategoriesStatusInput: { id: $id, isActive: $isActive }
              )
            }
            `,
      variables: {
        id,
        isActive,
      },
    },
  }).catch((e: any) => (data = e.response));
  return data;
}
